import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AdditionalCouponDialog, AdditionalCouponDrawer } from "@/components/Coupons/AdditionalCouponContents";
import CheckLoginDialog from "@/components/modal/CheckLoginDialog";
import { AvailableRelatedProductsModal } from "@/components/Product/Handout/RelatedProducts/AvailableRelatedProductsModal";
import Dialog from "@/components/Reviews/Detail/Dialog";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { LIBRARIES_INDEX_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import useLegacyCouponReceive from "./legacy/useLegacyCouponReceive";
import { useLegacyPassLogic } from "./legacy/useLegacyPassLogic";
import { usePurchaseStore } from "./purchaseStore";
const PurchaseModals = (param)=>{
    let { product  } = param;
    const { usePassConfirmed  } = useLegacyPassLogic({
        product
    });
    const { isMobile  } = useWindowDimensions();
    const router = useRouter();
    const { handoutCoupons  } = useLegacyCouponReceive({
        id: product.id,
        price: product.price
    });
    const { isModalOpen , modalProps , closeModal , showAvailableRelatedProductsModal , showSignInModal , showCouponModal , setFlags  } = usePurchaseStore((state)=>({
            isModalOpen: state.isModalOpen,
            modalProps: state.modalProps,
            closeModal: state.closeModal,
            showAvailableRelatedProductsModal: state.showAvailableRelatedProductsModal,
            showSignInModal: state.showSignInModal,
            showCouponModal: state.showCouponModal,
            setFlags: state.setFlags
        }));
    var _handoutCoupons_coupons, _handoutCoupons_coupons1;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Dialog, {
                // NOTE: HandoutPassSectionModal과 중첩시 뒤로 밀리지 않도록 2008로 설정
                // HandoutPassSectionModal의 depth는 1007이지만, 이 모달이 쓰는 common/Overlay의 StyledOverlay는 depth + 1000을 z-index로 설정하여 2007이 됨
                zIndex: 2008,
                isOpen: isModalOpen,
                title: /*#__PURE__*/ _jsx(_Fragment, {
                    children: "이용권을 사용했어요."
                }),
                onClose: closeModal,
                prefix: {
                    label: "닫기",
                    variant: "soft",
                    handleClick: closeModal
                },
                suffix: {
                    label: "자료 보관함 바로가기",
                    variant: "solid",
                    handleClick: ()=>{
                        mixpanelEvent("Popup Button Clicked", {
                            //팝업 mx-9
                            "Popup Type": "Use Pass",
                            "Popup Title": "이용권을 사용했어요.",
                            "Button Name": "자료 보관함 바로가기",
                            "Button URL": LIBRARIES_INDEX_PAGE
                        });
                        router.push(LIBRARIES_INDEX_PAGE);
                        closeModal();
                    }
                },
                ...modalProps
            }),
            showAvailableRelatedProductsModal && /*#__PURE__*/ _jsx(AvailableRelatedProductsModal, {
                isOpen: showAvailableRelatedProductsModal,
                onClose: ()=>setFlags({
                        showAvailableRelatedProductsModal: false
                    }),
                usePassConfirmed: usePassConfirmed
            }),
            /*#__PURE__*/ _jsx(CheckLoginDialog, {
                open: showSignInModal,
                onClose: ()=>setFlags({
                        showSignInModal: false
                    })
            }),
            isMobile ? /*#__PURE__*/ _jsx(AdditionalCouponDrawer, {
                anchor: "bottom",
                open: showCouponModal,
                handleClose: ()=>setFlags({
                        showCouponModal: false
                    }),
                handoutCoupons: (_handoutCoupons_coupons = handoutCoupons === null || handoutCoupons === void 0 ? void 0 : handoutCoupons.coupons) !== null && _handoutCoupons_coupons !== void 0 ? _handoutCoupons_coupons : []
            }) : /*#__PURE__*/ _jsx(AdditionalCouponDialog, {
                open: showCouponModal,
                handleClose: ()=>setFlags({
                        showCouponModal: false
                    }),
                handoutCoupons: (_handoutCoupons_coupons1 = handoutCoupons === null || handoutCoupons === void 0 ? void 0 : handoutCoupons.coupons) !== null && _handoutCoupons_coupons1 !== void 0 ? _handoutCoupons_coupons1 : []
            })
        ]
    });
};
export default PurchaseModals;
